/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Данные для инициализации wizq-платежа на клиенте.
 * Передаются в wqapi.requestPayment(skuID, skuQuantity=1, skuUnitPrice, skuName, skuImageURL, ...).
 * Единый grant-on-webhook path для всех платформ (Hange и Mobage/GMO):
 * SkuId = product.wizqSkuId если задан, иначе XOR(product.id) для Mobage/GMO.
 * Fxid-ордер создаётся только в webhook updateInventory.
 * @export
 * @interface FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantData
 */
export interface FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantData {
    /**
     * Числовой идентификатор SKU для wqapi.requestPayment.
     * Равен product.wizqSkuId (Hange) или XOR(product.id) (Mobage/GMO).
     * @type {number}
     * @memberof FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantData
     */
    SkuId: number;
    /**
     * Локализованное название товара (ja-JP).
     * @type {string}
     * @memberof FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantData
     */
    ItemName: string;
    /**
     * Цена в целевой валюте wizq-платформы (MOBACOIN/HANCOIN).
     * @type {number}
     * @memberof FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantData
     */
    SkuUnitPrice: number;
    /**
     * URL картинки товара.
     * @type {string}
     * @memberof FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantData
     */
    SkuImageURL: string;
}

/**
 * Check if a given object implements the FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantData interface.
 */
export function instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantData(value: object): value is FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantData {
    if (!('SkuId' in value) || value['SkuId'] === undefined) return false;
    if (!('ItemName' in value) || value['ItemName'] === undefined) return false;
    if (!('SkuUnitPrice' in value) || value['SkuUnitPrice'] === undefined) return false;
    if (!('SkuImageURL' in value) || value['SkuImageURL'] === undefined) return false;
    return true;
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantDataFromJSON(json: any): FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantData {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantDataFromJSONTyped(json, false);
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantData {
    if (json == null) {
        return json;
    }
    return {
        
        'SkuId': json['SkuId'],
        'ItemName': json['ItemName'],
        'SkuUnitPrice': json['SkuUnitPrice'],
        'SkuImageURL': json['SkuImageURL'],
    };
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantDataToJSON(json: any): FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantData {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantDataToJSONTyped(json, false);
}

export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantDataToJSONTyped(value?: FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultWizQMerchantData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'SkuId': value['SkuId'],
        'ItemName': value['ItemName'],
        'SkuUnitPrice': value['SkuUnitPrice'],
        'SkuImageURL': value['SkuImageURL'],
    };
}

